import { Controller } from "@hotwired/stimulus";

// An expandable row: the trigger is a real <button> whose aria-expanded
// reflects the state. The preview HTML is fetched the first time the row opens
// (or on connect when it starts open). Opening one row closes the others.
export default class extends Controller {
  static targets = ["body", "button", "panel"];
  static values = { open: Boolean, url: String };

  connect() {
    if (this.openValue) this.load();
    this.closeIfOther = (event) => {
      if (event.detail.opened !== this.element) this.setOpen(false);
    };
    document.addEventListener("chart-peek:opened", this.closeIfOther);
  }

  disconnect() {
    document.removeEventListener("chart-peek:opened", this.closeIfOther);
  }

  toggle() {
    const expand = this.panelTarget.hidden;
    this.setOpen(expand);
    if (expand) {
      this.dispatch("opened", { target: document, detail: { opened: this.element } });
      this.load();
    }
  }

  setOpen(open) {
    this.panelTarget.hidden = !open;
    this.buttonTarget.setAttribute("aria-expanded", String(open));
  }

  async load() {
    if (this.loaded || this.loading) return;
    this.loading = true;
    this.bodyTarget.textContent = "Loading preview...";

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });
      // 422 carries a friendly message fragment; anything else is a failure.
      if (!response.ok && response.status !== 422) throw new Error(response.status);
      this.bodyTarget.innerHTML = await response.text();
      this.loaded = true;
    } catch {
      this.bodyTarget.textContent = "Could not load the preview. Close and reopen to try again.";
    } finally {
      this.loading = false;
    }
  }
}
